import { render, staticRenderFns } from "./NotesDialog.vue?vue&type=template&id=caf98a16"
import script from "./NotesDialog.vue?vue&type=script&lang=js"
export * from "./NotesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports